module.exports = __webpack_public_path__ + "img/39.5654ed49.jpg";